import Alert from '@mui/material/Alert'
import { useFormatMessage } from '@/translations/useFormatMessage'
import { radius } from '@/styles/designTokens'

interface SystemHealthBannerProps {
	systemHealth: 'degraded' | 'down'
}

export function SystemHealthBanner({ systemHealth }: SystemHealthBannerProps) {
	const { t } = useFormatMessage()

	const isDegraded = systemHealth === 'degraded'

	return (
		<Alert
			severity={isDegraded ? 'warning' : 'error'}
			// role="status" (aria-live="polite") for degraded — non-interrupting informational notice.
			// role="alert" (aria-live="assertive") for down — urgent, must interrupt.
			role={isDegraded ? 'status' : 'alert'}
			aria-live={isDegraded ? 'polite' : 'assertive'}
			aria-atomic="true"
			sx={{
				borderRadius: radius.none,
				justifyContent: 'center',
				'& .MuiAlert-message': { flexGrow: 0 },
			}}
		>
			{isDegraded
				? t('component:systemHealthBanner:degraded:message')
				: t('component:systemHealthBanner:down:message')}
		</Alert>
	)
}
